import React from "react";
import "./index.css";
import { createStore } from "redux";
import { Provider } from "react-redux";
import App from "./App";
// import rootReducer from "./state/items/reducers/index";
import rootReducer from "./state/index";
import * as serviceWorker from "./serviceWorker";
import { createRoot } from "react-dom/client";

const store = createStore(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

// store.subscribe(() => console.log(store.getState()));

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
